import React from 'react';
import SelectField from './form/SelectField';

const RoleSelect = props => (
  <SelectField mode="multiple" placeholder="Select role" {...props} />
);

export default RoleSelect;
